import { render, staticRenderFns } from "./alarms.vue?vue&type=template&id=60dc13d4&"
import script from "./alarms.vue?vue&type=script&lang=js&"
export * from "./alarms.vue?vue&type=script&lang=js&"
import style0 from "./alarms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports